/**
 * @generated SignedSource<<f545bb491446d8c25062876169b01045>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelColorMappingInput = {
  colorID: number;
  merchantCode: string;
  salesChannelID: string;
};
export type previewSetModelColorMappingSalesChannelsMutation$variables = {
  modelColorMappings: ReadonlyArray<ModelColorMappingInput>;
  modelID: string;
};
export type previewSetModelColorMappingSalesChannelsMutation$data = {
  readonly setModelColorMapping: ReadonlyArray<{
    readonly colorID: number;
    readonly merchantCode: string;
  }> | null;
};
export type previewSetModelColorMappingSalesChannelsMutation = {
  response: previewSetModelColorMappingSalesChannelsMutation$data;
  variables: previewSetModelColorMappingSalesChannelsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelColorMappings"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelColorMappings",
        "variableName": "modelColorMappings"
      },
      {
        "kind": "Variable",
        "name": "modelID",
        "variableName": "modelID"
      }
    ],
    "concreteType": "ModelColorMapping",
    "kind": "LinkedField",
    "name": "setModelColorMapping",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "colorID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "merchantCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "previewSetModelColorMappingSalesChannelsMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "previewSetModelColorMappingSalesChannelsMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "336025a1c7a303f57a6be86abc03ff1a",
    "id": null,
    "metadata": {},
    "name": "previewSetModelColorMappingSalesChannelsMutation",
    "operationKind": "mutation",
    "text": "mutation previewSetModelColorMappingSalesChannelsMutation(\n  $modelID: ID!\n  $modelColorMappings: [ModelColorMappingInput!]!\n) {\n  setModelColorMapping(modelID: $modelID, modelColorMappings: $modelColorMappings) {\n    colorID\n    merchantCode\n  }\n}\n"
  }
};
})();

(node as any).hash = "74a1d6651391f07043ae0c17203a87be";

export default node;
